module.exports = __webpack_public_path__ + "img/dirty_shower.2d356f8f.svg";